import HeaderSection from "../../components/Header/HeaderSection"
import CardTransparent from "../../components/CockpitCards/CardTransparent"
import DiaNewRecord from "./DiaNewRecord"
import Grid from '@mui/material/Grid'

export default function RecordsText() {

    
    return (

    <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Your health records" 
            headline_grey = "in one secure place -"
            headline_p2 = "chronological and available anytime"

            text1 = "Medical records hold important, sensitive information about you — including diseases, injuries, vaccinations, care history and more."
            text2 = "It is paramount to keep your medical records and data protected, but at the same time available for you and your doctors - in one place."

            text3 = {
            
            <Grid container>
              <Grid item sx={{mt:2, display:'flex', justifyContent: 'flex-start', }}> 
            
                  <DiaNewRecord />
            
              </Grid>
            </Grid> }

            />
    }/>
            
  )
}